import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLojas } from '../regional-e-loja/services';
import registerUser, { deleteUser, resetUser, updateUser } from './services';

interface IStateRegisterUsuario {
  statusRegister: "" | "success" | "failed" | "loading",
  statusDelete: "" | "success" | "failed" | "loading",
  statusUpdate: "" | "success" | "failed" | "loading",
  statusReset: "" | "success" | "failed" | "loading",
  lojasByUser: [],
  feedbackError: string
}

interface IRequestUserAddAndUpdate {
  nome: string,
  login: string,
  contato: string,
  email: string,
  nivel: string,
  id?: string,
  idLoja: string,
  idRegional: string
}


export const actionRegisterUsuario: any = createAsyncThunk(
  "REGISTER_USUARIO",
  async (data: IRequestUserAddAndUpdate) => {
    delete data.id
    const request = await registerUser({ ...data })
    return request
  }
)

export const actionUpdateUsuario: any = createAsyncThunk(
  "UPDATE_USUARIO",
  async (data: IRequestUserAddAndUpdate) => {
    const request = await updateUser({ ...data })
    return request
  }
)

export const getLojasforUser:any = createAsyncThunk(
  "GET_LOJAS_BY_USER_EDIT",
  async (idRegional: string) => {
    const { data } = await getLojas({ idRegional })
    return data
  }
)

export const actionDeleteUser: any = createAsyncThunk(
  "DELETE_USER",
  async (id: string) => {
    const { data } = await deleteUser(id)
    return data;
  }
)

export const actionResetUser: any = createAsyncThunk(
  "RESET_USER",
  async (data: IRequestUserAddAndUpdate) => {
    const request = await resetUser({ ...data })
    return request
  }
)

const registerUsuarioSlice = createSlice({
  name: "REGISTER_USUARIO",
  initialState: <IStateRegisterUsuario> {
    statusRegister: "",
    statusDelete: "",
    statusUpdate: "",
    statusReset: "",
    lojasByUser: [],
    feedbackError: ""
  },
  reducers: {
    actionReset: (state) => {
      state.statusRegister = "";
      state.feedbackError = "";
      state.statusRegister =  "";
      state.statusDelete =  "";
      state.statusUpdate =  "";
      state.statusReset =  "";
    }
  },
  extraReducers: {
    [actionRegisterUsuario.pending]: (state) => {
      state.statusRegister = "loading"
      state.feedbackError = ""
    },
    [actionRegisterUsuario.fulfilled]: (state, { payload }) => {
      state.statusRegister = "success"
      state.feedbackError = ""
    },
    [actionRegisterUsuario.rejected]: (state, { error }) => {
      state.statusRegister = "failed"
      state.feedbackError = error.message
    },

    [actionUpdateUsuario.pending]: (state) => {
      state.statusUpdate = "loading"
      state.feedbackError = ""
    },
    [actionUpdateUsuario.fulfilled]: (state, { payload }) => {
      state.statusUpdate = "success"
      state.feedbackError = ""
    },
    [actionUpdateUsuario.rejected]: (state, { error }) => {
      state.statusUpdate = "failed"
      state.feedbackError = error.message
    },

    [actionDeleteUser.pending]: (state) => {
      state.statusDelete = "loading"
      state.feedbackError = ""
    },
    [actionDeleteUser.fulfilled]: (state, { payload }) => {
      state.statusDelete = "success"      
      state.feedbackError = ""
    },
    [actionDeleteUser.rejected]: (state, { error }) => {
      state.statusDelete = "failed"
      state.feedbackError = error.message
    },

    [actionResetUser.pending]: (state) => {
      state.statusReset = "loading"
      state.feedbackError = ""
    },
    [actionResetUser.fulfilled]: (state, { payload }) => {
      state.statusReset = "success"
      state.feedbackError = ""
    },
    [actionResetUser.rejected]: (state, { error }) => {
      state.statusReset = "failed"
      state.feedbackError = error.message
    },

    [getLojasforUser.fulfilled]: (state, { payload }) => {
      state.lojasByUser = payload
      state.feedbackError = ""
    },

  }
})
export const { actionReset } = registerUsuarioSlice.actions;
export default registerUsuarioSlice.reducer